module.exports = __webpack_public_path__ + "b1b8b91885e7d61c1de11b1cc2958fe2.svg";